import React, { useState, useEffect } from "react";
import { ChevronRight, Phone, Mail, MapPin } from "react-feather";
import { Link } from "react-router-dom";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import axios from "axios";
import { baseurl } from "../Baseurl";
import Swal from "sweetalert2"; // Import SweetAlert2
import {
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaInstagram,
  FaPinterest,
} from "react-icons/fa";

const ContactUs = () => {
  const [footerDetails, setFooterDetails] = useState(null);
  
  // State for form fields
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  // Fetch existing footer details
  const fetchFooterDetails = async () => {
    try {
      const response = await axios.get(`${baseurl}getFooterDetails`);
      if (response.data && response.data.data) {
        setFooterDetails(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching footer details:", error);
    }
  };

  useEffect(() => {
    fetchFooterDetails();
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${baseurl}contactSubmit`, formData);

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: "Thank you for contacting us. We will get back to you soon.",
          confirmButtonColor: "#FFC107", // Matching your warning/yellow theme
        });
        
        // Reset form
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        throw new Error("Failed to send message");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong! Please try again later.",
      });
      console.error("Contact Form Error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <VisitorNavbar />
      <div className="py-4" style={{ backgroundColor: '#ebe7e7' }}>
        <section className="mb-5">
          <div className="container">
            <div className="row g-5">
              <div className="col-md-6">
                <div className="reviewcls mb-3">
                  <div className="mt-2 text-start">
                    <h2>Get In Touch</h2>
                  </div>
                  <p className="text-start product-desc mb-3">
                    Techspares India is the easy way to buy and sell your scientific
                    equipment. We can assist you in posting your items and
                    contacting sellers.
                  </p>

                  <div>
                    {footerDetails?.address && (
                      <div className="mb-3">
                        <div className="text-start text-warning fz2 st1 mb-2"><MapPin size={15} /> Visit Us</div>
                        <div className="text-start">{footerDetails.address}</div>
                      </div>
                    )}

                    {footerDetails?.phone && (
                      <div className="mb-3">
                        <div className="text-start">
                          <Phone size={15} /> Call us: {footerDetails.phone}
                        </div>
                      </div>
                    )}

                    {footerDetails?.email && (
                      <div>
                        <div className="text-start">
                          <Mail size={15} /> Mail us: {footerDetails.email}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="social-icons mt-2">
                    {/* ... Social Icons (Existing Logic) ... */}
                    {footerDetails?.facebook && <a href={footerDetails.facebook} target="_blank" rel="noopener noreferrer"><FaFacebook size={20} /></a>}
                    {footerDetails?.linkedin && <a href={footerDetails.linkedin} target="_blank" rel="noopener noreferrer"><FaLinkedin size={20} /></a>}
                    {footerDetails?.youtube && <a href={footerDetails.youtube} target="_blank" rel="noopener noreferrer"><FaYoutube size={20} /></a>}
                    {footerDetails?.instagram && <a href={footerDetails.instagram} target="_blank" rel="noopener noreferrer"><FaInstagram size={20} /></a>}
                    {footerDetails?.pinterest && <a href={footerDetails.pinterest} target="_blank" rel="noopener noreferrer"><FaPinterest size={20} /></a>}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="reviewcls">
                  <h2 className="text-start">Leave A Reply</h2>
                  <p className="payttl text-start">
                    Your Email Address Will Not Be Published. Required Fields Are Marked *
                  </p>
                  
                  <form className="contact-form text-start" onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="firstName"
                          className="form-control"
                          placeholder="Enter your first name"
                          value={formData.firstName}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <input
                          type="text"
                          id="lastName"
                          className="form-control"
                          placeholder="Enter your last name"
                          value={formData.lastName}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-12">
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Enter your email address"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-12">
                        <input
                          type="tel"
                          id="phone"
                          className="form-control"
                          placeholder="Enter your phone number"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-12">
                        <textarea
                          id="message"
                          className="form-control"
                          rows="4"
                          placeholder="Write your message here"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        ></textarea>
                      </div>
                    </div>

                    <div className="mt-2">
                      <button 
                        type="submit" 
                        className="btn submitbtnn w-100" 
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Sending..." : "Submit Now"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="map-container">
        <div className="google-map">
          <iframe
            title="Techspares India Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.121169231!2d73.9145!3d18.567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTjCsDM0JzAxLjIiTiA3M8KwNTQnNTIuMiJF!5e0!3m2!1sen!2sin!4v1622544567890!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;